<template>
    <div class="md-layout">
		<div class="md-layout-item md-medium-size-50 md-size-50">
			<h4>ការគ្រប់គ្រងគូប៉ុង</h4>
		</div>
		<div class="md-layout-item md-medium-size-100 md-size-100">
			<md-card>
				<md-card-content>
					<loading v-if="!loaded" />
					<div v-if="loaded">
                        <md-table>
                            <md-table-row>
                                <md-table-head></md-table-head>
                                <md-table-head>ឈ្មោះគូប៉ុង</md-table-head>
                                <md-table-head>បញ្ចុះតម្លៃ</md-table-head>
                                <md-table-head>លេខកូដគូប៉ុង</md-table-head>
                                <md-table-head>ថ្ងៃផុតកំណត់</md-table-head>
                            </md-table-row>
            
                            <md-table-row v-for="(coupon, index) in oneTimeCouponList">
                                <md-table-cell>{{ index + 1}}</md-table-cell>
                                <md-table-cell>{{ coupon.name }}</md-table-cell>
                                <md-table-cell v-if="coupon.type == 'price'"> បញ្ចុះតម្លៃ ${{coupon.discount_value}}</md-table-cell>
									<md-table-cell v-if="coupon.type == 'percentage'">បញ្ចុះតម្លៃ {{coupon.discount_value}}%</md-table-cell>
                                <md-table-cell>{{ coupon.code }}</md-table-cell>
                                <md-table-cell v-if="coupon.total === 1">{{ config.datelify(coupon.expiry_date)[1] }}</md-table-cell>
                                <md-table-cell v-if="coupon.total === 0"><span class="red">បានប្រើ</span></md-table-cell>
                            </md-table-row>
                        </md-table>
            
					</div>
				</md-card-content>
			</md-card>
		</div>
	</div>
</template>

<script>
	export default {
		created() {
			this.getOneTimeCoupon();
		},
		data() {
			return {
				loaded: false,
				oneTimeCouponList: []
			}
		},
		methods: {
			getOneTimeCoupon(offset = 0, replace = true) {
				this.$http.get(this.config.api + "/user/coupon/get_one_time_coupon/"+ this.$route.params.hash +"/" + offset).then(data => {

					this.loaded = true;
					this.oneTimeCouponList = replace ? data.body.data : this.oneTimeCouponList.concat(data.body.data)
				})
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/pages/Coupons/Detail.vue